module.exports = [
  "Läden/SB-Märkte",
  "Ausstellungsfläche",
  "SB-Markt",
  "Einkaufszentrum",
  "Kaufhaus",
  "Verkaufshalle",
  "Factory Outlet",
  "Kiosk",
  "Laden",
  "Verkaufsfläche",
  "Ladenflächen",
  "Gewerbezentrum",
  "Servicefläche",
  "Gastronomie / Beherbergungen",
  "Bar",
  "Cafe",
  "Diskothek",
  "Laden/Einzelhandel",
];



// WEBPACK FOOTER //
// ./src/data/einzelhandel.js